import {
  Drawer,
  DrawerContent,
  Accordion,
  Text,
  DrawerOverlay,
  useDisclosure,
  Flex,
  Icon,
  Table,
  Thead,
  Th,
  Tbody,
  Tr,
  TableContainer,
  DrawerFooter,
  Tooltip,
} from '@chakra-ui/react'
import React from 'react'
import { AiOutlineArrowLeft, AiOutlineUser } from 'react-icons/ai'
import { FiEdit } from 'react-icons/fi'
import { Item } from './Item'
import { Button } from '../../../../../../components/Button'
import { api } from '../../../../../../services/api'
import { useMutation, useQueryClient } from 'react-query'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useOrcamentoPedido } from '../../../../../../contexts/OrcamentoPedidoProvider'
import { format } from 'date-fns'

async function updateContatoCliente({ id_contato, numero_nota }) {
  const response = await api.put('/site/v2/orcamento-crm/atualiza-contato-orcamento', {
    id_contato,
    numero_nota,
  })

  return response.data
}

export function ModalContato({ infoProposta }) {
  const { pedidoBloqueado } = useOrcamentoPedido()
  const INITIAL_VALUE = {
    nome_parceiro: infoProposta.nome_parceiro,
    email: infoProposta.email_parceiro,
    celular: infoProposta.celular_parceiro,
    telefone: infoProposta.telefone_parceiro,
    codigo_parceiro: infoProposta.cliente.codigo_parceiro,
    codigo_contato: infoProposta?.codigo_contato,
  }

  const { isOpen, onOpen, onClose } = useDisclosure()
  const { numeroProposta: numProposta } = useParams()
  const [selectedItem, setSelectedItem] = React.useState(INITIAL_VALUE || null)
  const btnRef = React.useRef()

  const queryClient = useQueryClient()

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: updateContatoCliente,
    onSuccess: (data) => {
      queryClient.setQueryData(['items', numProposta], (oldData) => {
        return {
          ...oldData,
          informacao_da_proposta: {
            ...oldData.informacao_da_proposta,
            nome_contato: data.informacao_da_proposta.nome_contato,
            email_parceiro: data.informacao_da_proposta.email_contato,
            celular_contato: data.informacao_da_proposta.celular_contato,
            telefone_contato: data.informacao_da_proposta.telefone_contato,
            codigo_contato: data.informacao_da_proposta.codigo_contato,
            cliente: {
              ...data.informacao_da_proposta.cliente,
              data_retorno: data.informacao_da_proposta.cliente.data_retorno
                ? format(new Date(data.informacao_da_proposta.cliente.data_retorno), 'dd/MM/yyyy')
                : null,
            },
            valida_proposta_nova: data.informacao_da_proposta.valida_proposta_nova,
            contato_site: data.contato_site,
          },
        }
      })

      onClose()
    },
  })

  const handleSelectItem = (item) => {
    setSelectedItem(item)
  }

  async function handleUpdateContato() {
    await mutateAsync({
      id_contato: selectedItem.codigo_contato,
      numero_nota: infoProposta.num_proposta,
    })
  }

  useEffect(() => {
    setSelectedItem(INITIAL_VALUE)
  }, [infoProposta])

  return (
    <>
      <Flex alignItems="center" gap={2} onClick={onOpen} cursor="pointer" pointerEvents={pedidoBloqueado ? 'none' : 'auto'}>
        <Icon as={AiOutlineUser} color="#378BBF" fontSize="20px" />{' '}
        <Tooltip label={infoProposta?.nome_contato}>
          <Text maxW="full" isTruncated>
            {infoProposta.nome_contato || 'Sem contato'}
          </Text>
        </Tooltip>
        | <strong>{infoProposta?.info_contato?.length}</strong>
        <Icon as={FiEdit} color="#378BBF" fontSize="20px" />
      </Flex>

      <Drawer isOpen={isOpen} onClose={onClose} finalFocusRef={btnRef} placement="bottom">
        <DrawerOverlay />
        <DrawerContent minH="100vh">
          <Text bgColor="#378BBF" textAlign="center" color="#F5F5F5" textTransform="uppercase" py="14px">
            CONTATO | {infoProposta.nome_parceiro} | {infoProposta.cliente.codigo_parceiro}
          </Text>

          <Accordion reduceMotion allowToggle>
            <TableContainer mt={5} maxH={'calc(100vh - 200px)'} overflowY="auto" w="100%">
              <Table variant="simple" fontSize="13px">
                <Thead position="sticky" top="0">
                  <Tr>
                    <Th bgColor="#378BBF" color="white" />
                    <Th bgColor="#378BBF" color="white" textAlign="center">
                      Código
                    </Th>
                    <Th bgColor="#378BBF" color="white">
                      Contato
                    </Th>
                    <Th bgColor="#378BBF" color="white">
                      Email
                    </Th>
                    <Th bgColor="#378BBF" color="white">
                      Celular
                    </Th>
                    <Th bgColor="#378BBF" color="white">
                      Fixo
                    </Th>
                    <Th bgColor="#378BBF" color="white" />
                  </Tr>
                </Thead>
                <Tbody>
                  {infoProposta?.info_contato?.map((contato, index) => (
                    <Item
                      contato={contato}
                      key={index}
                      isOdd={index % 2 === 0}
                      selectItem={handleSelectItem}
                      isSelected={selectedItem?.codigo_contato === contato?.codigo_contato}
                    />
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          </Accordion>

          <DrawerFooter position="sticky" mt="auto" bottom="0" boxShadow="0px 3px 6px rgba(0, 0, 0, 0.635)">
            <Flex alignItems="center" justifyContent="end" w="100%">
              <Button
                maxW="181px"
                w="100%"
                fontSize="15px"
                fontWeight="semibold"
                bgColor="transparent"
                color="#FFA200"
                border="1px solid #FFA200"
                onClick={onClose}
              >
                <AiOutlineArrowLeft style={{ marginRight: '5px' }} />
                Voltar
              </Button>

              <Button maxW="181px" w="100%" ml={3} fontSize="15px" fontWeight="semibold" isLoading={isLoading} onClick={handleUpdateContato}>
                Confirmar
              </Button>
            </Flex>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  )
}
